export enum UserRole {
  USER = "User",
  ADMINISTRATOR = "Administrator",
  DRAW_ASSISTANT = "Draw Assistant",
}
